import React, { useState, useEffect } from 'react';
import './Features.css';
import { Link } from 'react-router-dom';

const Features = () => {
  const [selectedCard, setSelectedCard] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const features = [
    {
      icon: '📍',
      title: 'Rastreo en Tiempo Real',
      description: 'Seguimiento GPS preciso con actualizaciones cada segundo desde cualquier lugar del mundo.'
    },
    {
      icon: '⚡',
      title: 'Velocidad Instantánea',
      description: 'Respuesta inmediata con 99.9% de precisión y localización al instante.'
    },
    {
      icon: '🔒',
      title: 'Seguridad de Grado Militar',
      description: 'Encriptación avanzada con autenticación biométrica y datos completamente seguros.'
    },
    {
      icon: '📱',
      title: 'App Móvil Inteligente',
      description: 'Control total desde tu smartphone con interfaz intuitiva y fácil de usar.'
    },
    {
      icon: '🎯',
      title: 'Alertas Inteligentes',
      description: 'Notificaciones personalizables para geocercas, velocidad y eventos importantes.'
    },
    {
      icon: '📊',
      title: 'Reportes Detallados',
      description: 'Análisis completo de rutas, tiempos y estadísticas de uso detalladas.'
    }
  ];

  const handleCardClick = (index) => {
    setSelectedCard(index);
  };

  const closeModal = () => {
    setSelectedCard(null);
  };

  const handleNavigation = (path) => {
    window.scrollTo(0, 0);
    // The Link component will handle the navigation
  };

  return (
    <section id="features" className="features">
      <div className="features-container">
        <div className="features-header">
          <h2 className="features-title">Descubre Nuestros Productos</h2>
          <p className="features-subtitle">
            Desarrollado por expertos en GPS, para usuarios que necesitan precisión y confiabilidad.
          </p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div
              key={index}
              className="feature-card"
              onClick={() => handleCardClick(index)}
            >
              <img
                src={
                  index === 0 ? "assets/images/p88l_1.jpg" :
                    index === 1 ? "assets/images/T399L_blue_gradient.jpg" :
                      index === 2 ? "assets/images/T711L_blue_gradient.jpg" :
                        index === 3 ? "assets/images/md500s_blue_gradient.jpg" :
                          index === 4 ? "assets/images/TA255L_blue_gradient.jpg" :
                            "assets/images/T633L_blue_gradient.jpg"
                }
                alt="Distracker Product"
                className="feature-image"
              />
            </div>
          ))}
        </div>

        <div className="features-cta">
          <Link to="/tienda/categoria/3" className="video-button" onClick={() => handleNavigation('/tienda/categoria/3')}>
            <video
              src={isMobile ? "assets/video/Adquiere_Tu_Sim_Small_Screen.mp4" : "assets/video/adquiere_tu_sim_enc.mp4"}
              autoPlay
              muted
              loop
              className="cta-video"
            />
          </Link>
        </div>
      </div>

      {/* Modal */}
      {selectedCard !== null && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>×</button>
            <img
              src={
                selectedCard === 0 ? "assets/images/p88l_1.jpg" :
                  selectedCard === 1 ? "assets/images/T399L_blue_gradient.jpg" :
                    selectedCard === 2 ? "assets/images/T711L_blue_gradient.jpg" :
                      selectedCard === 3 ? "assets/images/md500s_blue_gradient.jpg" :
                        selectedCard === 4 ? "assets/images/TA255L_blue_gradient.jpg" :
                          "assets/images/T633L_blue_gradient.jpg"
              }
              alt="Distracker Product"
              className="modal-image"
            />
            <div className="modal-actions">
              <Link to="/tienda" className="btn-view-product" onClick={() => handleNavigation('/tienda')}>
                Ir a productos
              </Link>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Features; 